import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmsContentService, UiTextKind } from '../services/cms-content.service';

/**
 * Resolves a CMS UiText key to its localized text, e.g. `{{ 'si_pts_chrome_welcome_header' | cmsText | async }}`.
 * Falls back to the key itself on a miss, same convention as UitextService.
 */
@Pipe({
  name: 'cmsText',
  standalone: true,
})
export class CmsTextPipe implements PipeTransform {

  constructor(private cms: CmsContentService, @Inject(LOCALE_ID) private locale: string) { }

  transform(key: string, kind: UiTextKind = 'ChromeLabel'): Observable<string> {
    return this.cms.getByKey(key, this.locale, kind).pipe(
      map(dto => dto?.text?.length ? dto.text : key)
    );
  }
}
